import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import type { CardAction } from '@omni/ai/features/card.schema';

/**
 * Tappable chip row for card-level `actions[]` and per-insight `actions[]`.
 * Each chip emits its {@link CardAction}; the `<nova-card>` host maps
 *  - kind 'prompt' → send `value` as the next user turn,
 *  - kind 'tool'   → invoke the named client `@AITool`.
 * This leaf is purely presentational — it never dispatches itself.
 */
@Component({
  selector: 'card-actions',
  standalone: true,
  imports: [CommonModule, IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-actions.component.html',
  styleUrls: ['./card-actions.component.scss'],
})
export class CardActionsComponent {
  @Input() actions: CardAction[] | null = null;

  @Output() action = new EventEmitter<CardAction>();

  trackAction(_i: number, a: CardAction): string {
    return a.kind + ':' + a.value;
  }

  actionIcon(a: CardAction): string {
    return a.kind === 'tool' ? 'flash-outline' : 'chatbubble-ellipses-outline';
  }

  onTap(a: CardAction): void {
    this.action.emit(a);
  }

  onKeydown(event: KeyboardEvent, a: CardAction): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onTap(a);
    }
  }
}
